import { render, staticRenderFns } from "./BeneficiaireForm.vue?vue&type=template&id=288bb2da"
import script from "./BeneficiaireForm.vue?vue&type=script&lang=js"
export * from "./BeneficiaireForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports